import React from 'react';
import './style.scss';

/**
 * TableContent component.
 *
 * @param {Object} props - Props for the TableContent component.
 * @param {string} props.title - The title of the content block.
 * @param {string} props.mainContent - The main content of the block.
 * @param {string} props.subContent - The sub content of the block.
 * @param {string} [props.mainContentClass] - The CSS class for the main content block.
 * @returns {JSX.Element} The TableContent component.
 * @example
 *  <TableContent
        title={"title text"}
        mainContent={"mainContent text"}
        subContent={"subContent text"}
        mainContentClass={"additional class"}
    />
 */
function TableContent({ title, mainContent, subContent, mainContentClass }) {
    return (
      <div className="info-content-block">
        <div className="title">{title}</div>
        <div className={`main-content ${mainContentClass}`}>{mainContent}</div>
        <div className="sub-content">{subContent}</div>
      </div>
    );
};

TableContent.defaultProps = {
    title: '',
    mainContent: '',
    subContent: '',
    mainContentAriaLabel: '',
};

export default TableContent;
